import { get } from "lodash"
import { createQueryStringSelector } from "selectors/queryString"

const EMPTY_ARRAY = []

export const getFactorCategoryId = createQueryStringSelector("factorCategory", "beta")
export const getOnly = createQueryStringSelector("only")
export const getDisabled = createQueryStringSelector("disabled", EMPTY_ARRAY)
export const getFocusedChartLine = state => get(state, "modules.analyzeCompositeComposition.focusedChartLine")
